import React from 'react';
import { Link } from "react-router-dom";
import { useLocale } from 'context/LanguageContext';
import PATHS from 'constants/paths';

import LanguageSwitcher from 'components/general/LanguageSwitcher';
import HeaderActions from './inner/HeaderActions';
import HeaderLogos from "./inner/HeaderLogos";
import HeaderBottom from "./inner/HeaderBottom";
import HeaderAppButtons from "./inner/HeaderAppButtons";

import { Logo } from "svg/icons";

import "./styles/header.scss";
import "./styles/header-responsive.scss";
import "./styles/header-contrast.scss";


export default function Header() { 

	const locale = useLocale( true );

	return (
		<header className="header">

			<div className="header__top df-ac">
			
				<Link to={ PATHS.MAIN + "?lang=" + locale } className="header__logo">
					<Logo />
				</Link>

				<LanguageSwitcher/>

				<HeaderLogos/>

				<HeaderActions />

				<HeaderAppButtons/>
			</div>

			<HeaderBottom/>
		</header>
	)
}